export class Taak {
  constructor(public id: string, public name: string  , public toetsid: string) { }
}